import orderObject from './orderObject';

const rearrangeDataOrder = (data, order) => data.map((row) => orderObject(row, order));

export default rearrangeDataOrder;
